import { OnChanges, SimpleChanges } from '@angular/core';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ContactUsService } from './contact-us.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent extends FeaturesBaseComponent implements OnInit, OnChanges, OnDestroy {
  @Input() retailerInfo: any;
  tilaEmail: any;
  tilaMobile: any;
  tilaTimings: any = {};

  constructor(private contactService: ContactUsService) {
    super();
    this.uiConfigValuesService.getUIConfigValues('Tila email').subscribe(

      res => {

        if (res['httpcode'] == 200) {

          this.tilaEmail = res['data']

        }

      }

    )
    this.uiConfigValuesService.getUIConfigValues('Tila Customer Service No').subscribe(res => {
      if (res['httpcode'] == 200) {
       this.tilaMobile = res['data']
      }
    })

    this.uiConfigValuesService.getUIConfigValues('timings').subscribe(
      res => {
        if (res['httpcode'] == 200) {
          this.tilaTimings = res['data'][0];
          this.tilaTimings=this.tilaTimings.replace(/\"/g, "")
          console.log(this.tilaTimings);
        }
      }
    )
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngOnChanges(changes: SimpleChanges): void {
    changes['retailerInfo'] ? this.retailerInfo = changes['retailerInfo'].currentValue : this.retailerInfo;
  }
}
